import React from 'react';
import { Box, Flex, Link } from 'rebass/styled-components';
import { Message } from '@getro/rombo';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const linkStyles = { textDecoration: 'underline', cursor: 'pointer' };

export const ContactsLinkedinSync = ({ linkedinSync, activeNetwork }) => {
  const syncStatus = linkedinSync?.syncStatus;
  const reconnectPath = `/networks/${activeNetwork.slug}/linkedin/reconnect`;

  return (
    <Flex flexDirection="column" sx={{ gap: '16px', '&& > div:last-child': { mx: '16px', mb: '8px' } }}>
      {syncStatus === 'not_completed' && (
        <Message>We’re syncing your LinkedIn connections, this may take up to 3 hours.</Message>
      )}
      {syncStatus === 'not_logged_in_to_linkedin' && (
        <Message type="warning">
          {"Your LinkedIn sync has stopped, we're not seeing an active session on "}
          <Box
            as="a"
            href="https://www.linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            color="text.main"
            sx={linkStyles}
          >
            www.linkedin.com
          </Box>
          {'. Sign in or '}
          <Link color="text.main" as={NavLink} to={reconnectPath}>
            verify your setup
          </Link>
          .
        </Message>
      )}
      {syncStatus === 'no_recent_sync' && (
        <Message type="warning">
          {
            "Your LinkedIn sync has stopped, the Getro extension hasn't checked in recently. Confirm it's running in your usual browser or "
          }
          <Link color="text.main" as={NavLink} to={reconnectPath}>
            verify your setup
          </Link>
          .
        </Message>
      )}
      {syncStatus === 'reconnection_needed' && (
        <Message type="warning">
          Your LinkedIn sync has stalled. Start it again by{' '}
          <Link color="text.main" as={NavLink} to={reconnectPath}>
            verifying your setup
          </Link>
          .
        </Message>
      )}
    </Flex>
  );
};

ContactsLinkedinSync.propTypes = {
  linkedinSync: PropTypes.object.isRequired,
  activeNetwork: PropTypes.object.isRequired,
};
